import { render, staticRenderFns } from "./ChatErrorConnection.vue?vue&type=template&id=f989c6b0&scoped=true"
import script from "./ChatErrorConnection.vue?vue&type=script&lang=js"
export * from "./ChatErrorConnection.vue?vue&type=script&lang=js"
import style0 from "./ChatErrorConnection.vue?vue&type=style&index=0&id=f989c6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f989c6b0",
  null
  
)

export default component.exports